import "./suppressConsole";

import React from "react";
import ReactDOM from "react-dom";

import firebase from "js/firebase";

//
// entry point
//

console.log("App Build:", window.buildVersion);
if (window.isOfflinePlayer) {
    console.log("Offline Player Desktop App");
}

// firebase
firebase.initializeApp(window.baiFirebase.config);

// react
const root = document.createElement("div");
root.id = "react-root";
root.style.display = "contents";
document.body.appendChild(root);

// firebase dependent code
(async () => {
    // preload
    await import(/* webpackMode: "eager" */ "js/preload");

    const { IntegratorController } = await import(/* webpackMode: "eager" */ "common/integrators/IntegratorController");
    await IntegratorController.initApp();

    const { default: App } = await import(/* webpackMode: "eager" */ "./App");

    // render
    ReactDOM.render(<App />, root);
})();
